// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-input-element{width:100%;height:100%;outline:none;display:block;transition:0.3s;-webkit-appearance:none}.form-input-element::placeholder{color:inherit;font:inherit;opacity:0.7}.form-input-element:focus{border-color:#318BF5 !important}\n", ""]);
// Exports
module.exports = exports;
